import { render, staticRenderFns } from "./StationLogsItem.vue?vue&type=template&id=3f243378&lang=pug&"
import script from "./StationLogsItem.vue?vue&type=script&lang=js&"
export * from "./StationLogsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports